import { z } from "zod";
export const DTOPagination = z.object({
    limit: z.string().optional(),
    offset: z.string().optional(),
});
